export enum DASHBOARD_VIEW {
  ALL_TIME = 'all-time',
  THIS_YEAR = 'this-year',
}

export const DEFAULT_DASHBOARD_VIEW = DASHBOARD_VIEW.THIS_YEAR;
